.avatar-container {
  height: 12rem;
  width: 12rem;
  border-radius: var(--border-radius-medium);
  background-color: #ffd1de;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3.2rem;
}

.image {
  height: 12rem;
  width: 12rem;
  border-radius: var(--border-radius-medium);
  object-fit: cover;
}

.delete {
  position: absolute;
  right: 0.8rem;
  top: 0.8rem;
  opacity: 0;
  transform: translateX(1rem) scale(0.95);
  transition: all 300ms cubic-bezier(0.25, 0.1, 0.25, 1) 0s;
}

.card {
  border-radius: var(--border-radius-medium);
  background-color: var(--card-bg-color);
  width: 100%;
  padding-top: 100%;
  position: relative;

  &:hover {
    .delete {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
  }
}

.content {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.6rem;
}

.name {
  font-size: 1.6rem;
  font-weight: bold;
  margin-top: 1.6rem;
  text-align: center;
}

.role {
  color: #8a8f98;
  margin-top: 0.4rem;
  text-align: center;
}
